// TODO: for some reason the /api/tts endpoint is not working
// the audio is not coming back

import { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import { getAudioStatus, getVoice } from 'src/modules/Redux/slices/screen';
import { AudioControlContext } from './AudioControlContext';

const voiceSettings = {
    stability: 0.45,
    similarity_boost: 0.8,
};

// TODO make this more s e c u r e
const apiKey = process.env.REACT_APP_ELEVEN_LABS;

export const useEleven = () => {
    const audioControl = useContext(AudioControlContext); // Use the context here
    if (!audioControl) {
        throw new Error(
            'useAudio must be used within an AudioControllerProvider'
        );
    }
    const { playAudio, stopAudio } = audioControl;
    const audioOn = useSelector(getAudioStatus);
    const voice = useSelector(getVoice);

    const fetchStream = useCallback(
        async (text: string) => {
            try {
                const response = await fetch(
                    `https://api.elevenlabs.io/v1/text-to-speech/${voice}/stream`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            accept: '*/*',
                            'xi-api-key': apiKey || '',
                        },
                        body: JSON.stringify({
                            text,
                            // model_id: 'eleven_multilingual_v2',
                            model_id: 'eleven_turbo_v2',
                            voice_settings: voiceSettings,
                        }),
                    }
                );

                if (response.ok) {
                    const blob = await response.blob();
                    const url = URL.createObjectURL(blob);
                    return url;
                } else {
                    console.error(
                        'Error fetching Text-to-Speech stream:',
                        response.statusText,
                        response
                    );
                    return null;
                }
            } catch (error: any) {
                console.error(
                    '2 Error fetching Text-to-Speech stream:',
                    error,
                    error?.response
                );
                return null;
            }
        },
        [voice]
    );

    const play = async (text: string, onAudioEnd: () => void = () => {}) => {
        if (!audioOn) {
            setTimeout(onAudioEnd, 5000);
            return;
        }
        const url = await fetchStream(text);

        if (url) {
            await playAudio(url, onAudioEnd);
        }

        return url;
    };

    return { fetchStream, play };
};
